const TextError = (props) => {
  return (
    <div style={{ color: "#d32f2f" }}>
      <small>{props.children}</small>
    </div>
  );
};

export default TextError;
